import { fetchBaseQuery } from '@reduxjs/toolkit/query/react';
import { tokenStorage } from '../../utils/tokenStorage';

export const createBaseQuery = (baseUrl: string) => fetchBaseQuery({
  baseUrl,
  credentials: 'include',
  prepareHeaders: (headers) => {
    const token = tokenStorage.getAccessToken();
    if (token) {
      headers.set('authorization', `Bearer ${token}`);
    }
    return headers;
  },
});